export const POSITION = {
    TOP_RIGHT: 'top-right',
    TOP_LEFT: 'top-left',
    BOTTOM_RIGHT: 'bottom-right',
    BOTTOM_LEFT: 'bottom-left',
    TOP_CENTER: 'top',
    BOTTOM_CENTER: 'bottom-center',
    CENTER: 'center'
}